import React, { ReactNode } from "react"

import Caption from "../../../../design-system/caption"
import { classNames } from "../../../../utils/class-names"
import * as styles from "./index.module.scss"

type Props = {
  title: ReactNode
  children: ReactNode
  rowsCount?: "two" | "three"
}

const NavList = ({ title, children, rowsCount = "three" }: Props) => {
  return (
    <div className={styles.navListContainer}>
      <Caption className={styles.title}>{title}</Caption>
      <div
        className={classNames(
          styles.navItemsContainer,
          styles[`${rowsCount}Rows`],
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default NavList
